import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth-context';
import { useUserDoc } from '../lib/users';
import { takeReturnTo } from '../lib/returnTo';

/**
 * BACK TO THE BAG (2026-09-25). A parent who scanned a costume label while
 * signed out is sent home to sign in. Once her account is active and she is on
 * home, this takes her straight back to that pickup page instead of leaving
 * her on the home screen with the bag in her hand. Only a fresh costume pickup
 * path is ever remembered (lib/returnTo.ts), and it is used once.
 *
 * Mounted once in App.tsx for adult sessions, outside Landing, so every home
 * (Director, staff, family, Admin) gets the same return trip. Renders nothing.
 * Its useUserDoc listens to the same users/{uid} document App already does,
 * which Firestore serves from the one shared listen.
 */
export default function PickupReturnTrip() {
  const { user } = useAuth();
  const { userDoc, loading } = useUserDoc();
  const location = useLocation();
  const navigate = useNavigate();
  const active = !!user && !loading && userDoc?.status === 'active';
  useEffect(() => {
    if (!active || location.pathname !== '/') return;
    const path = takeReturnTo();
    if (path) navigate(path, { replace: true });
  }, [active, location.pathname, navigate]);
  return null;
}
